import CreateOrder from '../../../views/document/children/order/Create.vue';
import OrderInfo from '../../../views/document/children/order/Info.vue';
import PublicParams from '../../../views/document/children/public/Params.vue'
import PublicError from '../../../views/document/children/public/Error.vue';
import Computed from '../../../views/document/children/computed/Computed.vue';
import SkuSearch from '../../../views/document/children/sku/Seach.vue';
import SkuInfo from '../../../views/document/children/sku/Info.vue';
import Express from '../../../views/document/children/express/Express.vue';
import Business from '../../../views/document/children/description/Business.vue';
import Apply from '../../../views/document/children/description/Apply.vue';
import Develop from '../../../views/document/children/description/Develop.vue';
import OrderStep from '../../../views/document/children/description/Order.vue';
import PayStep from '../../../views/document/children/description/Pay.vue';

let route = [{
    path: 'order/create',
    component: CreateOrder,
    meta: {
      bodyColor: '#fff'
    },
  },
  {
    path: 'order/info',
    component: OrderInfo,
    meta: {
      bodyColor: '#fff'
    },
  }, {
    path: 'express',
    component: Express,
    meta: {
      bodyColor: '#fff'
    },
  }, {
    path: 'public/params',
    component: PublicParams,
    meta: {
      bodyColor: '#fff'
    },
  },
  {
    path: 'public/error',
    component: PublicError,
    meta: {
      bodyColor: '#fff'
    }
  },
  {
    path: 'computed/price',
    component: Computed,
    meta: {
      bodyColor: '#fff'
    }
  },
  {
    path: 'sku/search',
    component: SkuSearch,
    meta: {
      bodyColor: '#fff'
    }
  },
  {
    path: 'sku/info',
    component: SkuInfo,
    meta: {
      bodyColor: '#fff'
    }
  },
  {
    path: '',
    component: Business,
    meta: {
      bodyColor: '#fff'
    }
  },
  {
    path: 'description/apply',
    component: Apply,
    meta: {
      bodyColor: '#fff'
    }
  },
  {
    path: 'description/develop',
    component: Develop,
    meta: {
      bodyColor: '#fff'
    }
  },
  {
    path: 'description/order',
    component: OrderStep,
    meta: {
      bodyColor: '#fff'
    }
  },
  {
    path: 'description/pay',
    component: PayStep,
    meta: {
      bodyColor: '#fff'
    }
  }
]

export default route;